import { requestedPaProducts, requestedPaBrands } from "./requestedPaProducts.js";

// Legacy PA System starter product catalog (kept below for reference only).
// Prices are editable starter values (BDT) prepared 2026-08-05; see priceStatus
// for provenance (internal use only — never surface priceStatus in customer PDFs).
// Do not alter supplied model names or starter prices.
const rawPaProducts = [
  {
    "id": "cmx-ea-60a",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "EA-A Series",
    "componentType": "mixer-amplifier",
    "productName": "Mixer Amplifier with USB/SD/FM/Bluetooth",
    "model": "EA-60A",
    "unit": "Nos.",
    "unitPrice": 14000,
    "currency": "BDT",
    "priceStatus": "web/local-reference",
    "active": true,
    "powerWatts": 60
  },
  {
    "id": "cmx-ea-120a",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "EA-A Series",
    "componentType": "mixer-amplifier",
    "productName": "Mixer Amplifier with USB/SD/FM/Bluetooth",
    "model": "EA-120A",
    "unit": "Nos.",
    "unitPrice": 21000,
    "currency": "BDT",
    "priceStatus": "web/local-reference",
    "active": true,
    "powerWatts": 120
  },
  {
    "id": "cmx-ea-240a",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "EA-A Series",
    "componentType": "mixer-amplifier",
    "productName": "Mixer Amplifier with USB/SD/FM/Bluetooth",
    "model": "EA-240A",
    "unit": "Nos.",
    "unitPrice": 24900,
    "currency": "BDT",
    "priceStatus": "web-listed",
    "active": true,
    "powerWatts": 240
  },
  {
    "id": "cmx-ea-350a",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "EA-A Series",
    "componentType": "mixer-amplifier",
    "productName": "Mixer Amplifier with USB/SD/FM/Bluetooth",
    "model": "EA-350A",
    "unit": "Nos.",
    "unitPrice": 39500,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 350
  },
  {
    "id": "cmx-ea-500a",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "EA-A Series",
    "componentType": "mixer-amplifier",
    "productName": "Mixer Amplifier with USB/SD/FM/Bluetooth",
    "model": "EA-500A",
    "unit": "Nos.",
    "unitPrice": 52000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 500
  },
  {
    "id": "cmx-pa-4120mx",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "PA-4500MX",
    "componentType": "multi-zone-mixer-amplifier",
    "productName": "4-Zone Mixer Amplifier",
    "model": "PA-4120MX",
    "unit": "Nos.",
    "unitPrice": 65000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 120,
    "numberOfZones": 4
  },
  {
    "id": "cmx-pa-4240mx",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "PA-4500MX",
    "componentType": "multi-zone-mixer-amplifier",
    "productName": "4-Zone Mixer Amplifier",
    "model": "PA-4240MX",
    "unit": "Nos.",
    "unitPrice": 88000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 240,
    "numberOfZones": 4
  },
  {
    "id": "cmx-pa-4350mx",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "PA-4500MX",
    "componentType": "multi-zone-mixer-amplifier",
    "productName": "4-Zone Mixer Amplifier",
    "model": "PA-4350MX",
    "unit": "Nos.",
    "unitPrice": 108000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 350,
    "numberOfZones": 4
  },
  {
    "id": "cmx-pa-4500mx",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "PA-4500MX",
    "componentType": "multi-zone-mixer-amplifier",
    "productName": "4-Zone Mixer Amplifier",
    "model": "PA-4500MX",
    "unit": "Nos.",
    "unitPrice": 135000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 500,
    "numberOfZones": 4
  },
  {
    "id": "cmx-pa-4500rm",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "PA-4500MX",
    "componentType": "paging-microphone",
    "productName": "4-Zone Remote Paging Microphone",
    "model": "PA-4500RM",
    "unit": "Nos.",
    "unitPrice": 35000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "cmx-pa-4500sv",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "PA-4500MX",
    "componentType": "remote-volume-controller",
    "productName": "Remote Source and Volume Controller",
    "model": "PA-4500SV",
    "unit": "Nos.",
    "unitPrice": 18000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "cmx-pa-4500wp",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "PA-4500MX",
    "componentType": "remote-control-panel",
    "productName": "Remote In-Wall Control Panel",
    "model": "PA-4500WP",
    "unit": "Nos.",
    "unitPrice": 12000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "cmx-pa-100dm",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "PA Series",
    "componentType": "audio-source",
    "productName": "DVD/MP3/USB Audio Source Player",
    "model": "PA-100DM",
    "unit": "Nos.",
    "unitPrice": 22000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "cmx-csk-613ht",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "ceiling-speaker",
    "productName": "6.5-Inch 2-Way Ceiling Speaker",
    "model": "CSK-613HT",
    "unit": "Nos.",
    "unitPrice": 6500,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 15,
    "speakerTapOptions": [7.5, 15, 30]
  },
  {
    "id": "cmx-csk-613htm",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "ceiling-speaker",
    "productName": "6.5-Inch 2-Way Ceiling Speaker",
    "model": "CSK-613HTM",
    "unit": "Nos.",
    "unitPrice": 7500,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 15,
    "speakerTapOptions": [3.8, 7.5, 15, 30]
  },
  {
    "id": "cmx-wsk-530t",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "wall-speaker",
    "productName": "2-Way Wall-Mount Speaker",
    "model": "WSK-530T",
    "unit": "Nos.",
    "unitPrice": 6800,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 15,
    "speakerTapOptions": [15, 30]
  },
  {
    "id": "cmx-wsk-530tw",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "wall-speaker",
    "productName": "2-Way Wall-Mount Speaker",
    "model": "WSK-530TW",
    "unit": "Nos.",
    "unitPrice": 7200,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 15,
    "speakerTapOptions": [15, 30]
  },
  {
    "id": "cmx-wsk-610f",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "wall-speaker",
    "productName": "2-Way Wall-Mount Speaker",
    "model": "WSK-610F",
    "unit": "Nos.",
    "unitPrice": 4400,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 10,
    "speakerTapOptions": [6, 10]
  },
  {
    "id": "cmx-clsk-30e",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "column-speaker",
    "productName": "Outdoor Column Speaker",
    "model": "CLSK-30E",
    "unit": "Nos.",
    "unitPrice": 9500,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 30,
    "speakerTapOptions": [15, 30]
  },
  {
    "id": "cmx-clsk-60e",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "column-speaker",
    "productName": "Outdoor Column Speaker",
    "model": "CLSK-60E",
    "unit": "Nos.",
    "unitPrice": 15000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 60,
    "speakerTapOptions": [30, 60]
  },
  {
    "id": "cmx-hsk-30fh",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "horn-speaker",
    "productName": "Outdoor Horn Speaker",
    "model": "HSK-30FH",
    "unit": "Nos.",
    "unitPrice": 6500,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 30,
    "speakerTapOptions": [3.75, 7.5, 15, 30]
  },
  {
    "id": "cmx-psk-530k",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "pendant-speaker",
    "productName": "Pendant Speaker",
    "model": "PSK-530K",
    "unit": "Nos.",
    "unitPrice": 8500,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 15,
    "speakerTapOptions": [3.8, 7.5, 15, 30]
  },
  {
    "id": "cmx-rs8",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "full-range-speaker",
    "productName": "8-Inch Professional Full-Range Speaker",
    "model": "RS8",
    "unit": "Nos.",
    "unitPrice": 25000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "cmx-rs10",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "full-range-speaker",
    "productName": "10-Inch Professional Full-Range Speaker",
    "model": "RS10",
    "unit": "Nos.",
    "unitPrice": 32000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "cmx-rs12",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "full-range-speaker",
    "productName": "12-Inch Professional Full-Range Speaker",
    "model": "RS12",
    "unit": "Nos.",
    "unitPrice": 45000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "cmx-rs15",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "full-range-speaker",
    "productName": "15-Inch Professional Full-Range Speaker",
    "model": "RS15",
    "unit": "Nos.",
    "unitPrice": 58000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "cmx-sx16-4",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "audio-mixer",
    "productName": "16-Channel Digital Mixer",
    "model": "SX16-4",
    "unit": "Nos.",
    "unitPrice": 85000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "cmx-ds-2300",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "professional-power-amplifier",
    "productName": "Two-Channel Power Amplifier",
    "model": "DS-2300",
    "unit": "Nos.",
    "unitPrice": 72000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "cmx-ds-4300",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "professional-power-amplifier",
    "productName": "Four-Channel Power Amplifier",
    "model": "DS-4300",
    "unit": "Nos.",
    "unitPrice": 115000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "cmx-pa-208ps",
    "brand": "CMX",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "power-sequencer",
    "productName": "Power Sequencer",
    "model": "PA-208PS",
    "unit": "Nos.",
    "unitPrice": 18000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "cmx-di-9700a",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-system-controller",
    "productName": "IP Network PA System Controller",
    "model": "DI-9700A",
    "unit": "Nos.",
    "unitPrice": 220000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "cmx-di-9700sf",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "management-software",
    "productName": "IP Network Audio System Software",
    "model": "DI-9700SF",
    "unit": "Nos.",
    "unitPrice": 90000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "cmx-di-9700ub",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "software-dongle",
    "productName": "Software USB Dongle",
    "model": "DI-9700UB",
    "unit": "Nos.",
    "unitPrice": 25000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "cmx-di-9700tm",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "network-paging-console",
    "productName": "IP Network Remote Paging Microphone",
    "model": "DI-9700TM",
    "unit": "Nos.",
    "unitPrice": 75000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "cmx-di-9700na",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-audio-interface",
    "productName": "IP Network Audio Encoder and Decoder",
    "model": "DI-9700NA",
    "unit": "Nos.",
    "unitPrice": 68000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "cmx-di-9710",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-audio-encoder",
    "productName": "IP Network Audio Encoder",
    "model": "DI-9710",
    "unit": "Nos.",
    "unitPrice": 52000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "cmx-di-9700fa",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "fire-alarm-interface",
    "productName": "IP Network Fire Alarm Panel",
    "model": "DI-9700FA",
    "unit": "Nos.",
    "unitPrice": 70000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "cmx-di-9700st",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "power-sequencer",
    "productName": "IP Power Sequencer",
    "model": "DI-9700ST",
    "unit": "Nos.",
    "unitPrice": 35000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "cmx-di-9760",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-amplifier",
    "productName": "IP Network Amplifier",
    "model": "DI-9760",
    "unit": "Nos.",
    "unitPrice": 55000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 60,
    "networkPortsRequired": 1
  },
  {
    "id": "cmx-di-97120",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-amplifier",
    "productName": "IP Network Amplifier",
    "model": "DI-97120",
    "unit": "Nos.",
    "unitPrice": 75000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 120,
    "networkPortsRequired": 1
  },
  {
    "id": "cmx-di-97240",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-amplifier",
    "productName": "IP Network Amplifier",
    "model": "DI-97240",
    "unit": "Nos.",
    "unitPrice": 110000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 240,
    "networkPortsRequired": 1
  },
  {
    "id": "cmx-di-97350",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-amplifier",
    "productName": "IP Network Amplifier",
    "model": "DI-97350",
    "unit": "Nos.",
    "unitPrice": 145000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 350,
    "networkPortsRequired": 1
  },
  {
    "id": "cmx-di-97500",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-amplifier",
    "productName": "IP Network Amplifier",
    "model": "DI-97500",
    "unit": "Nos.",
    "unitPrice": 185000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 500,
    "networkPortsRequired": 1
  },
  {
    "id": "cmx-di-97501",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-ceiling-speaker",
    "productName": "IP PoE Ceiling Speaker",
    "model": "DI-97501",
    "unit": "Nos.",
    "unitPrice": 28000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 30,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "cmx-di-97523p",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-wall-speaker",
    "productName": "IP PoE Wall-Mount Speaker",
    "model": "DI-97523P",
    "unit": "Nos.",
    "unitPrice": 42000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 30,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "cmx-di-9723p",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-wall-speaker",
    "productName": "IP Network Powered Wall Speaker",
    "model": "DI-9723P",
    "unit": "Nos.",
    "unitPrice": 48000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 40,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "cmx-di-9730p",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-column-speaker",
    "productName": "Outdoor IP PoE Column Speaker",
    "model": "DI-9730P",
    "unit": "Nos.",
    "unitPrice": 55000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 30,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "cmx-di-97603",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-horn-speaker",
    "productName": "Outdoor IP PoE Horn Speaker",
    "model": "DI-97603",
    "unit": "Nos.",
    "unitPrice": 48000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 30,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "cmx-di-97603s",
    "brand": "CMX",
    "installationType": "ip",
    "systemFamily": "DI-9700",
    "componentType": "ip-music-horn-speaker",
    "productName": "Outdoor IP PoE Music Horn Speaker",
    "model": "DI-97603S",
    "unit": "Nos.",
    "unitPrice": 58000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 30,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "bosch-ple-1ma030-eu",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "PLENA",
    "componentType": "mixer-amplifier",
    "productName": "Priority Mixer Amplifier",
    "model": "PLE-1MA030-EU",
    "unit": "Nos.",
    "unitPrice": 48000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 30
  },
  {
    "id": "bosch-ple-1ma060-eu",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "PLENA",
    "componentType": "mixer-amplifier",
    "productName": "Priority Mixer Amplifier",
    "model": "PLE-1MA060-EU",
    "unit": "Nos.",
    "unitPrice": 70000,
    "currency": "BDT",
    "priceStatus": "web-listed-converted",
    "active": true,
    "powerWatts": 60
  },
  {
    "id": "bosch-ple-1ma120-eu",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "PLENA",
    "componentType": "mixer-amplifier",
    "productName": "Priority Mixer Amplifier",
    "model": "PLE-1MA120-EU",
    "unit": "Nos.",
    "unitPrice": 88000,
    "currency": "BDT",
    "priceStatus": "web-listed-converted",
    "active": true,
    "powerWatts": 120
  },
  {
    "id": "bosch-ple-1me240-eu",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "PLENA",
    "componentType": "mixer-amplifier",
    "productName": "Mixer Amplifier",
    "model": "PLE-1ME240-EU",
    "unit": "Nos.",
    "unitPrice": 125000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 240
  },
  {
    "id": "bosch-ple-2ma120-eu",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "PLENA",
    "componentType": "multi-zone-mixer-amplifier",
    "productName": "2-Zone Mixer Amplifier",
    "model": "PLE-2MA120-EU",
    "unit": "Nos.",
    "unitPrice": 110000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 120
  },
  {
    "id": "bosch-ple-2ma240-eu",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "PLENA",
    "componentType": "multi-zone-mixer-amplifier",
    "productName": "2-Zone Mixer Amplifier",
    "model": "PLE-2MA240-EU",
    "unit": "Nos.",
    "unitPrice": 145000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 240
  },
  {
    "id": "bosch-ple-1cs",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "PLENA",
    "componentType": "paging-microphone",
    "productName": "All-Call Call Station",
    "model": "PLE-1CS",
    "unit": "Nos.",
    "unitPrice": 35000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "bosch-ple-1scs",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "PLENA",
    "componentType": "paging-microphone",
    "productName": "Heavy-Duty All-Call Call Station",
    "model": "PLE-1SCS",
    "unit": "Nos.",
    "unitPrice": 42000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "bosch-ple-2cs",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "PLENA",
    "componentType": "zone-paging-microphone",
    "productName": "2-Zone Call Station",
    "model": "PLE-2CS",
    "unit": "Nos.",
    "unitPrice": 60000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "bosch-lbb1950-10",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "PLENA",
    "componentType": "paging-microphone",
    "productName": "Tabletop Paging Microphone",
    "model": "LBB1950/10",
    "unit": "Nos.",
    "unitPrice": 36000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "bosch-lbc3090-01",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "ceiling-speaker",
    "productName": "Ceiling Loudspeaker",
    "model": "LBC3090/01",
    "unit": "Nos.",
    "unitPrice": 5500,
    "currency": "BDT",
    "priceStatus": "web-listed-converted",
    "active": true,
    "defaultSpeakerTapWatts": 6,
    "speakerTapOptions": [1.5, 3, 6]
  },
  {
    "id": "bosch-lbc3087-41",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "ceiling-speaker",
    "productName": "Flush-Mount Ceiling Loudspeaker",
    "model": "LBC3087/41",
    "unit": "Nos.",
    "unitPrice": 3500,
    "currency": "BDT",
    "priceStatus": "web-listed-converted",
    "active": true,
    "defaultSpeakerTapWatts": 6,
    "speakerTapOptions": [1.5, 3, 6]
  },
  {
    "id": "bosch-lhm0606-00",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "ceiling-speaker",
    "productName": "General-Purpose Ceiling Loudspeaker",
    "model": "LHM0606/00",
    "unit": "Nos.",
    "unitPrice": 4000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 6,
    "speakerTapOptions": [1.5, 3, 6]
  },
  {
    "id": "bosch-lb1-um06e-1",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "cabinet-speaker",
    "productName": "Metal Cabinet Loudspeaker",
    "model": "LB1-UM06E-1",
    "unit": "Nos.",
    "unitPrice": 9000,
    "currency": "BDT",
    "priceStatus": "web-listed-converted",
    "active": true,
    "defaultSpeakerTapWatts": 6,
    "speakerTapOptions": [1.5, 3, 6]
  },
  {
    "id": "bosch-lbc3018-01",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "cabinet-speaker",
    "productName": "Rectangular Metal Cabinet Loudspeaker",
    "model": "LBC3018/01",
    "unit": "Nos.",
    "unitPrice": 10000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 6,
    "speakerTapOptions": [1.5, 3, 6]
  },
  {
    "id": "bosch-la1-um20e-1",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "column-speaker",
    "productName": "Metal Column Loudspeaker",
    "model": "LA1-UM20E-1",
    "unit": "Nos.",
    "unitPrice": 42000,
    "currency": "BDT",
    "priceStatus": "web-listed-converted",
    "active": true,
    "defaultSpeakerTapWatts": 20,
    "speakerTapOptions": [2.5, 5, 10, 20]
  },
  {
    "id": "bosch-la1-um40e-1",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "column-speaker",
    "productName": "Metal Column Loudspeaker",
    "model": "LA1-UM40E-1",
    "unit": "Nos.",
    "unitPrice": 65000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 40,
    "speakerTapOptions": [5, 10, 20, 40]
  },
  {
    "id": "bosch-lbc3482-00",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "horn-speaker",
    "productName": "Horn Loudspeaker",
    "model": "LBC3482/00",
    "unit": "Nos.",
    "unitPrice": 20000,
    "currency": "BDT",
    "priceStatus": "web-listed-converted",
    "active": true,
    "defaultSpeakerTapWatts": 25,
    "speakerTapOptions": [6.25, 12.5, 25]
  },
  {
    "id": "bosch-lbc3484-00",
    "brand": "Bosch",
    "installationType": "wired",
    "systemFamily": "Commercial Speaker",
    "componentType": "horn-speaker",
    "productName": "Horn Loudspeaker",
    "model": "LBC3484/00",
    "unit": "Nos.",
    "unitPrice": 32000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 50,
    "speakerTapOptions": [12.5, 25, 50]
  },
  {
    "id": "bosch-pra-scs",
    "brand": "Bosch",
    "installationType": "ip",
    "systemFamily": "PRAESENSA",
    "componentType": "ip-system-controller",
    "productName": "Small System Controller",
    "model": "PRA-SCS",
    "unit": "Nos.",
    "unitPrice": 500000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "bosch-pra-scl",
    "brand": "Bosch",
    "installationType": "ip",
    "systemFamily": "PRAESENSA",
    "componentType": "ip-system-controller",
    "productName": "Large System Controller",
    "model": "PRA-SCL",
    "unit": "Nos.",
    "unitPrice": 900000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "bosch-pra-csld",
    "brand": "Bosch",
    "installationType": "ip",
    "systemFamily": "PRAESENSA",
    "componentType": "network-paging-console",
    "productName": "Desktop LCD Call Station",
    "model": "PRA-CSLD",
    "unit": "Nos.",
    "unitPrice": 290000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "bosch-pra-cslw",
    "brand": "Bosch",
    "installationType": "ip",
    "systemFamily": "PRAESENSA",
    "componentType": "network-paging-console",
    "productName": "Wall-Mount LCD Call Station",
    "model": "PRA-CSLW",
    "unit": "Nos.",
    "unitPrice": 320000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "bosch-pra-cse",
    "brand": "Bosch",
    "installationType": "ip",
    "systemFamily": "PRAESENSA",
    "componentType": "call-station-extension",
    "productName": "Call Station Extension",
    "model": "PRA-CSE",
    "unit": "Nos.",
    "unitPrice": 190000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "bosch-pra-ad604",
    "brand": "Bosch",
    "installationType": "ip",
    "systemFamily": "PRAESENSA",
    "componentType": "ip-amplifier",
    "productName": "600W 4-Channel Amplifier",
    "model": "PRA-AD604",
    "unit": "Nos.",
    "unitPrice": 560000,
    "currency": "BDT",
    "priceStatus": "web-listed-converted",
    "active": true,
    "powerWatts": 600,
    "networkPortsRequired": 1,
    "amplifierChannels": 4
  },
  {
    "id": "bosch-pra-ad608",
    "brand": "Bosch",
    "installationType": "ip",
    "systemFamily": "PRAESENSA",
    "componentType": "ip-amplifier",
    "productName": "600W 8-Channel Amplifier",
    "model": "PRA-AD608",
    "unit": "Nos.",
    "unitPrice": 680000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 600,
    "networkPortsRequired": 1,
    "amplifierChannels": 8
  },
  {
    "id": "bosch-pra-ar616",
    "brand": "Bosch",
    "installationType": "ip",
    "systemFamily": "PRAESENSA",
    "componentType": "ip-router-amplifier",
    "productName": "600W 16-Zone Router Amplifier",
    "model": "PRA-AR616",
    "unit": "Nos.",
    "unitPrice": 850000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 600,
    "networkPortsRequired": 1,
    "numberOfZones": 16
  },
  {
    "id": "bosch-pra-mps3",
    "brand": "Bosch",
    "installationType": "ip",
    "systemFamily": "PRAESENSA",
    "componentType": "power-supply",
    "productName": "Multifunction Power Supply",
    "model": "PRA-MPS3",
    "unit": "Nos.",
    "unitPrice": 450000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "bosch-pra-eol",
    "brand": "Bosch",
    "installationType": "ip",
    "systemFamily": "PRAESENSA",
    "componentType": "end-of-line-device",
    "productName": "End-of-Line Supervision Device",
    "model": "PRA-EOL",
    "unit": "Nos.",
    "unitPrice": 18000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "bosch-pra-apas",
    "brand": "Bosch",
    "installationType": "ip",
    "systemFamily": "PRAESENSA",
    "componentType": "management-server",
    "productName": "Advanced Public Address Server",
    "model": "PRA-APAS",
    "unit": "Nos.",
    "unitPrice": 650000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-nac-3120",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "power-amplifier",
    "productName": "Digital Power Amplifier",
    "model": "NAC-3120",
    "unit": "Nos.",
    "unitPrice": 36000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 120
  },
  {
    "id": "spon-nac-3240",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "power-amplifier",
    "productName": "Digital Power Amplifier",
    "model": "NAC-3240",
    "unit": "Nos.",
    "unitPrice": 55000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 240
  },
  {
    "id": "spon-nac-4100",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "power-amplifier",
    "productName": "Digital Power Amplifier",
    "model": "NAC-4100",
    "unit": "Nos.",
    "unitPrice": 125000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 1000
  },
  {
    "id": "spon-nac-4150",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "power-amplifier",
    "productName": "Digital Power Amplifier",
    "model": "NAC-4150",
    "unit": "Nos.",
    "unitPrice": 165000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 1500
  },
  {
    "id": "spon-nac-131",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "ceiling-speaker",
    "productName": "6W 100V Ceiling Speaker",
    "model": "NAC-131",
    "unit": "Nos.",
    "unitPrice": 4500,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 6,
    "speakerTapOptions": [3, 6]
  },
  {
    "id": "spon-nac-2304",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "wall-speaker",
    "productName": "6W Corridor Speaker",
    "model": "NAC-2304",
    "unit": "Nos.",
    "unitPrice": 5500,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 6,
    "speakerTapOptions": [3, 6]
  },
  {
    "id": "spon-nac-2305",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "wall-speaker",
    "productName": "40W 100V Wall-Mount Speaker",
    "model": "NAC-2305",
    "unit": "Nos.",
    "unitPrice": 9000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 40,
    "speakerTapOptions": [20, 40]
  },
  {
    "id": "spon-nac-221a",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "column-speaker",
    "productName": "20W Column Speaker",
    "model": "NAC-221A",
    "unit": "Nos.",
    "unitPrice": 10000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 20,
    "speakerTapOptions": [10, 20]
  },
  {
    "id": "spon-nac-2503",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "horn-speaker",
    "productName": "30W 100V Horn Speaker",
    "model": "NAC-2503",
    "unit": "Nos.",
    "unitPrice": 6000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 30,
    "speakerTapOptions": [15, 30]
  },
  {
    "id": "spon-nac-2510",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "horn-speaker",
    "productName": "50W 100V Horn Speaker",
    "model": "NAC-2510",
    "unit": "Nos.",
    "unitPrice": 9500,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 50,
    "speakerTapOptions": [25, 50]
  },
  {
    "id": "spon-nac-301h",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "cabinet-speaker",
    "productName": "30W Cabinet Speaker",
    "model": "NAC-301H",
    "unit": "Nos.",
    "unitPrice": 8500,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 30
  },
  {
    "id": "spon-nac-21",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "volume-controller",
    "productName": "100V Wall-Mount Volume Controller",
    "model": "NAC-21",
    "unit": "Nos.",
    "unitPrice": 3000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "spon-nac-22",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "volume-controller",
    "productName": "100V Wall-Mount Volume Controller",
    "model": "NAC-22",
    "unit": "Nos.",
    "unitPrice": 3500,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "spon-nac-23",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "volume-controller",
    "productName": "100V Wall-Mount Volume Controller",
    "model": "NAC-23",
    "unit": "Nos.",
    "unitPrice": 4200,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "spon-nac-24",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "NAC",
    "componentType": "volume-controller",
    "productName": "100V Wall-Mount Volume Controller",
    "model": "NAC-24",
    "unit": "Nos.",
    "unitPrice": 5000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "spon-xc-9000",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "management-software",
    "productName": "Audio Management Software",
    "model": "XC-9000",
    "unit": "Nos.",
    "unitPrice": 120000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-xc-9013",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "management-server",
    "productName": "Industrial Management Server",
    "model": "XC-9013",
    "unit": "Nos.",
    "unitPrice": 230000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-xc-9000usb",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "software-dongle",
    "productName": "Management Software USB Dongle",
    "model": "XC-9000USB",
    "unit": "Nos.",
    "unitPrice": 25000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-gen-9101n",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "network-paging-console",
    "productName": "Network Paging Console",
    "model": "GEN-9101N",
    "unit": "Nos.",
    "unitPrice": 52173,
    "currency": "BDT",
    "priceStatus": "user-quotation",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-gen-9102n",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "network-paging-console",
    "productName": "Network Paging Microphone",
    "model": "GEN-9102N",
    "unit": "Nos.",
    "unitPrice": 65000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-gen-9102t",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "network-paging-console",
    "productName": "Network Paging Microphone",
    "model": "GEN-9102T",
    "unit": "Nos.",
    "unitPrice": 75000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-xc-9038n",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "network-paging-console",
    "productName": "Network Paging Console",
    "model": "XC-9038N",
    "unit": "Nos.",
    "unitPrice": 130000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-gen-2001",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "network-paging-gateway",
    "productName": "Network Paging Gateway",
    "model": "GEN-2001",
    "unit": "Nos.",
    "unitPrice": 55000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-gen-3101a01",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-audio-interface",
    "productName": "IP Audio Converter",
    "model": "GEN-3101A01",
    "unit": "Nos.",
    "unitPrice": 48000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-gen-3001a03",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-audio-interface",
    "productName": "Network Audio Interface",
    "model": "GEN-3001A03",
    "unit": "Nos.",
    "unitPrice": 70000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-nac-5003",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "fire-alarm-interface",
    "productName": "IP Fire Alarm Interface Unit",
    "model": "NAC-5003",
    "unit": "Nos.",
    "unitPrice": 65000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-gen-5301p13",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-amplifier",
    "productName": "Network Integrated Amplifier",
    "model": "GEN-5301P13",
    "unit": "Nos.",
    "unitPrice": 85000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 130,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-gen-5301p26",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-amplifier",
    "productName": "Network Integrated Amplifier",
    "model": "GEN-5301P26",
    "unit": "Nos.",
    "unitPrice": 105000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 260,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-gen-5301p36",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-amplifier",
    "productName": "Network Integrated Amplifier",
    "model": "GEN-5301P36",
    "unit": "Nos.",
    "unitPrice": 125000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 360,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-gen-5301p50",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-amplifier",
    "productName": "Network Integrated Amplifier",
    "model": "GEN-5301P50",
    "unit": "Nos.",
    "unitPrice": 155000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 500,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-gen-5501p13",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-multi-zone-amplifier",
    "productName": "Network Multi-Zone Amplifier",
    "model": "GEN-5501P13",
    "unit": "Nos.",
    "unitPrice": 115000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 130,
    "networkPortsRequired": 1,
    "numberOfZones": 6
  },
  {
    "id": "spon-gen-5501p26",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-multi-zone-amplifier",
    "productName": "Network Multi-Zone Amplifier",
    "model": "GEN-5501P26",
    "unit": "Nos.",
    "unitPrice": 145000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 260,
    "networkPortsRequired": 1,
    "numberOfZones": 6
  },
  {
    "id": "spon-gen-5501p36",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-multi-zone-amplifier",
    "productName": "Network Multi-Zone Amplifier",
    "model": "GEN-5501P36",
    "unit": "Nos.",
    "unitPrice": 170000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 360,
    "networkPortsRequired": 1,
    "numberOfZones": 6
  },
  {
    "id": "spon-gen-5501p55",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-multi-zone-amplifier",
    "productName": "Network Multi-Zone Amplifier",
    "model": "GEN-5501P55",
    "unit": "Nos.",
    "unitPrice": 210000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 550,
    "networkPortsRequired": 1,
    "numberOfZones": 6
  },
  {
    "id": "spon-gen-5501p70",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-multi-zone-amplifier",
    "productName": "Network Multi-Zone Amplifier",
    "model": "GEN-5501P70",
    "unit": "Nos.",
    "unitPrice": 250000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 700,
    "networkPortsRequired": 1,
    "numberOfZones": 6
  },
  {
    "id": "spon-xc-9508p13",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "ip-amplifier",
    "productName": "Network Integrated Amplifier",
    "model": "XC-9508P13",
    "unit": "Nos.",
    "unitPrice": 90000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 130,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-xc-9508p26",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "ip-amplifier",
    "productName": "Network Integrated Amplifier",
    "model": "XC-9508P26",
    "unit": "Nos.",
    "unitPrice": 110000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 260,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-xc-9508p36",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "ip-amplifier",
    "productName": "Network Integrated Amplifier",
    "model": "XC-9508P36",
    "unit": "Nos.",
    "unitPrice": 130000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 360,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-xc-9508p50",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "ip-amplifier",
    "productName": "Network Integrated Amplifier",
    "model": "XC-9508P50",
    "unit": "Nos.",
    "unitPrice": 160000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 500,
    "networkPortsRequired": 1
  },
  {
    "id": "spon-nbs-2301p13",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "ip-multi-zone-amplifier",
    "productName": "Multi-Zone Network Mixer Amplifier",
    "model": "NBS-2301P13",
    "unit": "Nos.",
    "unitPrice": 105000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 130,
    "networkPortsRequired": 1,
    "numberOfZones": 4
  },
  {
    "id": "spon-nbs-2301p26",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "ip-multi-zone-amplifier",
    "productName": "Multi-Zone Network Mixer Amplifier",
    "model": "NBS-2301P26",
    "unit": "Nos.",
    "unitPrice": 135000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 260,
    "networkPortsRequired": 1,
    "numberOfZones": 4
  },
  {
    "id": "spon-nbs-2301p36",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "ip-multi-zone-amplifier",
    "productName": "Multi-Zone Network Mixer Amplifier",
    "model": "NBS-2301P36",
    "unit": "Nos.",
    "unitPrice": 160000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 360,
    "networkPortsRequired": 1,
    "numberOfZones": 4
  },
  {
    "id": "spon-nbs-2301p55",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "ip-multi-zone-amplifier",
    "productName": "Multi-Zone Network Mixer Amplifier",
    "model": "NBS-2301P55",
    "unit": "Nos.",
    "unitPrice": 200000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 550,
    "networkPortsRequired": 1,
    "numberOfZones": 4
  },
  {
    "id": "spon-nbs-2301p70",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "ip-multi-zone-amplifier",
    "productName": "Multi-Zone Network Mixer Amplifier",
    "model": "NBS-2301P70",
    "unit": "Nos.",
    "unitPrice": 235000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 700,
    "networkPortsRequired": 1,
    "numberOfZones": 4
  },
  {
    "id": "spon-nxt-2204p1k",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "NetLink",
    "componentType": "ip-multi-channel-amplifier",
    "productName": "4-Channel Network Amplifier",
    "model": "NXT-2204P1K",
    "unit": "Nos.",
    "unitPrice": 280000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 1000,
    "networkPortsRequired": 1,
    "amplifierChannels": 4
  },
  {
    "id": "spon-gen-6212a01",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-ceiling-speaker",
    "productName": "Network Ceiling Speaker",
    "model": "GEN-6212A01",
    "unit": "Nos.",
    "unitPrice": 22000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 10,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "spon-gen-6213a01",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-ceiling-speaker",
    "productName": "Network Ceiling Speaker",
    "model": "GEN-6213A01",
    "unit": "Nos.",
    "unitPrice": 27000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 20,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "spon-gen-6214a01",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-ceiling-speaker",
    "productName": "Network Ceiling Speaker",
    "model": "GEN-6214A01",
    "unit": "Nos.",
    "unitPrice": 32000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "spon-gen-6011a03",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-cabinet-speaker",
    "productName": "Network Cabinet Speaker",
    "model": "GEN-6011A03",
    "unit": "Nos.",
    "unitPrice": 44429.5,
    "currency": "BDT",
    "priceStatus": "user-quotation",
    "active": true,
    "powerWatts": 30,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "spon-gen-6013a01",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-cabinet-speaker",
    "productName": "Network Cabinet Speaker",
    "model": "GEN-6013A01",
    "unit": "Nos.",
    "unitPrice": 40000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "spon-gen-6392a01",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-horn-speaker",
    "productName": "Network Horn Speaker",
    "model": "GEN-6392A01",
    "unit": "Nos.",
    "unitPrice": 24000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 15,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "spon-gen-6393a01",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-horn-speaker",
    "productName": "Network Horn Speaker",
    "model": "GEN-6393A01",
    "unit": "Nos.",
    "unitPrice": 27072.5,
    "currency": "BDT",
    "priceStatus": "user-quotation",
    "active": true,
    "powerWatts": 15,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "spon-gen-6393a03",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-horn-speaker",
    "productName": "Network Horn Speaker",
    "model": "GEN-6393A03",
    "unit": "Nos.",
    "unitPrice": 38000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 30,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "spon-gen-6191a03",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-column-speaker",
    "productName": "Network Outdoor Column Loudspeaker",
    "model": "GEN-6191A03",
    "unit": "Nos.",
    "unitPrice": 48000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 30,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "spon-gen-6191a06",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-column-speaker",
    "productName": "Network Outdoor Column Loudspeaker",
    "model": "GEN-6191A06",
    "unit": "Nos.",
    "unitPrice": 65000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 60,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "spon-gen-6191a12",
    "brand": "SPON",
    "installationType": "ip",
    "systemFamily": "SIPLink",
    "componentType": "ip-column-speaker",
    "productName": "Network Outdoor Column Loudspeaker",
    "model": "GEN-6191A12",
    "unit": "Nos.",
    "unitPrice": 95000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 120,
    "networkPortsRequired": 1,
    "poeRequired": true,
    "builtInAmplifier": true
  },
  {
    "id": "spon-sap-q8",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "full-range-speaker",
    "productName": "8-Inch Full-Range Speaker",
    "model": "SAP-Q8",
    "unit": "Nos.",
    "unitPrice": 28000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 150
  },
  {
    "id": "spon-sap-q10",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "full-range-speaker",
    "productName": "10-Inch Full-Range Speaker",
    "model": "SAP-Q10",
    "unit": "Nos.",
    "unitPrice": 38000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 280
  },
  {
    "id": "spon-sap-q12",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "full-range-speaker",
    "productName": "12-Inch Full-Range Speaker",
    "model": "SAP-Q12",
    "unit": "Nos.",
    "unitPrice": 52000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 400
  },
  {
    "id": "spon-sap-q15",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "full-range-speaker",
    "productName": "15-Inch Full-Range Speaker",
    "model": "SAP-Q15",
    "unit": "Nos.",
    "unitPrice": 72000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "defaultSpeakerTapWatts": 700
  },
  {
    "id": "spon-sap-f12a",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "audio-mixer",
    "productName": "12-Channel Analog Mixing Console",
    "model": "SAP-F12A",
    "unit": "Nos.",
    "unitPrice": 45000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "spon-sap-f16a",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "audio-mixer",
    "productName": "16-Channel Analog Mixing Console",
    "model": "SAP-F16A",
    "unit": "Nos.",
    "unitPrice": 58000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "spon-sap-f1608s",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "audio-mixer",
    "productName": "16-Channel Digital Mixing Console",
    "model": "SAP-F1608S",
    "unit": "Nos.",
    "unitPrice": 135000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "id": "spon-sap-d2100a",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "professional-power-amplifier",
    "productName": "Professional Power Amplifier",
    "model": "SAP-D2100A",
    "unit": "Nos.",
    "unitPrice": 160000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 2000
  },
  {
    "id": "spon-sap-mx12a",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "stage-monitor",
    "productName": "Stage Monitor Speaker",
    "model": "SAP-MX12A",
    "unit": "Nos.",
    "unitPrice": 65000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true,
    "powerWatts": 400
  },
  {
    "id": "spon-sap-c115c",
    "brand": "SPON",
    "installationType": "wired",
    "systemFamily": "Professional Sound",
    "componentType": "subwoofer",
    "productName": "Subwoofer Speaker",
    "model": "SAP-C115C",
    "unit": "Nos.",
    "unitPrice": 75000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "brand": "TP-Link",
    "installationType": "ip",
    "systemFamily": "Common",
    "componentType": "poe-switch",
    "productName": "8-Port PoE Managed Network Switch",
    "model": "TL-SG2210P",
    "unit": "Nos.",
    "unitPrice": 12420,
    "currency": "BDT",
    "priceStatus": "user-quotation",
    "usablePoePorts": 8,
    "active": true
  },
  {
    "brand": "D-Link",
    "installationType": "ip",
    "systemFamily": "Common",
    "componentType": "network-cable",
    "productName": "CAT6 Network Cable",
    "model": "CAT6 Cable",
    "unit": "Box",
    "unitPrice": 22275,
    "currency": "BDT",
    "priceStatus": "user-quotation",
    "active": true
  },
  {
    "brand": "Generic",
    "installationType": "both",
    "systemFamily": "Common",
    "componentType": "equipment-rack",
    "productName": "Equipment Rack",
    "model": "Standard Equipment Rack",
    "unit": "Nos.",
    "unitPrice": 25000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "brand": "Generic",
    "installationType": "both",
    "systemFamily": "Common",
    "componentType": "ups",
    "productName": "Online UPS",
    "model": "Online UPS",
    "unit": "Nos.",
    "unitPrice": 45000,
    "currency": "BDT",
    "priceStatus": "estimated",
    "active": true
  },
  {
    "brand": "Generic",
    "installationType": "both",
    "systemFamily": "Common",
    "componentType": "accessories",
    "productName": "PA System Accessories",
    "model": "Speaker Cable, Power Cable, Connector, Clip, Tie and Combined Board",
    "unit": "Lot",
    "unitPrice": 30000,
    "currency": "BDT",
    "priceStatus": "user-quotation",
    "active": true
  },
  {
    "brand": "Mugnee Multiple Limited",
    "installationType": "both",
    "systemFamily": "Service",
    "componentType": "installation-service",
    "productName": "Installation & Configuration",
    "model": "Installation Service",
    "unit": "Job",
    "unitPrice": 50000,
    "currency": "BDT",
    "priceStatus": "user-quotation",
    "active": true
  }
];

function slugify(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-+|-+$)/g, "");
}

rawPaProducts.map((product, index) => ({
  ...product,
  id: product.id || `${slugify(product.brand)}-${slugify(product.model)}` || `pa-product-${index}`,
}));

export const paProducts = requestedPaProducts;

export const paBrands = requestedPaBrands;

export const PA_COMMON_SYSTEM_FAMILIES = ["Common", "Service"];

export function isCommonProduct(product) {
  return PA_COMMON_SYSTEM_FAMILIES.includes(product.systemFamily);
}
